const getters = {
  trackingList: state => state.trackingList,
    excessMaterials: state => state.excessMaterials,
  isExcessMaterialLoading: state => state.isExcessMaterialLoading,
};

export default getters;
